import { getAndroidAppBuildNumber } from 'shared/util/utility';
import { AnalyticalEvents, WebViewEventName, WebViewMessage, WebViewSubscriber, WebViewSubscriberCallback } from './interface';

function getBroadcastMethods() {
	return [
		// @ts-ignore
		window?.Android?.onEvent?.bind(window?.Android),
		// @ts-ignore
		window?.webkit?.messageHandlers?.iosListener?.postMessage?.bind(window?.webkit?.messageHandlers?.iosListener),
	].filter(Boolean);
}

let subscribers: WebViewSubscriber[] = [];

window.addEventListener('message', (event: MessageEvent) => {
	if (event.origin !== window.location.origin) {
		return;
	}

	if (typeof event.data !== 'string') {
		return;
	}

	try {
		const parsedData: WebViewMessage = JSON.parse(event.data);

		if (parsedData?.topic !== 'WebViewResponse') {
			return;
		}

		subscribers.forEach((subscriber) => subscriber.callBack(parsedData.event, parsedData.message));
	} catch (e) {
		console.error(e);
	}
});

function broadcast(eventName: WebViewEventName, message?: any) {
	const methods = getBroadcastMethods();
	if (methods.length) {
		methods[0](JSON.stringify({ topic: 'WebView', event: eventName, message }));
	}
}

function broadcastAnalytics(name: AnalyticalEvents, id?: { userId?: number; messageId?: string }) {
	const methods = getBroadcastMethods();
	if (methods.length) {
		methods[0](JSON.stringify({ topic: 'Analytics', name: name, ...id }));
	}
}

function subscribe(subscriberId: string, callBack: WebViewSubscriberCallback) {
	unsubscribe(subscriberId);
	subscribers.push({ subscriberId, callBack });
}

function unsubscribe(subscriberId: string) {
	subscribers = subscribers.filter((subscriber) => subscriber.subscriberId !== subscriberId);
}

function isEventAvailable(event: WebViewEventName) {
	switch (event) {
		case 'SHARE_TEXT':
			return getAndroidAppBuildNumber() >= 9;

		case 'COPY_TO_CLIPBOARD':
			return getAndroidAppBuildNumber() >= 10;

		case 'SHARE_IMAGE':
			return getAndroidAppBuildNumber() >= 14;

		default:
			return true;
	}
}

const WebView = {
	broadcast,
	subscribe,
	unsubscribe,
	isEventAvailable,
	broadcastAnalytics,
};

export default WebView;
